export const ProviderAiCommon = {
  key: 'ai',
}
